// removed by extract-text-webpack-plugin
module.exports = {"component":"_1vFfnYwQ9ZPO4z7Awf18tn","btn":"_1eqmZ5JTYS7Ow7_sAc9akp","item":"_3RJyk-VYIR_yqIn-avfkIr","radio":"_1f89N9frR1xlGyk6o2s2Z9","price":"ol0fh7qvGQnh1utB8DjDH","name":"fKgMvRCMaGYuNoCwnp_2t","content":"_1tZHVStbr9fwskDE6NFvzM"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ServiceDetailProductsModal/ServiceDetailProductsModal.scss
 ** module id = 1023
 ** module chunks = 0
 **/